import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'atsPropHasValue',
    standalone: false
})
export class AtsPropHasValuePipe implements PipeTransform {
	transform(obj: any[] | any, prop: string): any {
		if (Array.isArray(obj)) {
			return obj.reduce((prev, curr) => !!prev || (Object.hasOwnProperty.call(curr, prop) && !!curr[prop]));
		} else {
			return obj && Object.hasOwnProperty.call(obj, prop);
		}
	}
}
